import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Card from '../Common/Card/Card'

import './PharmacyStore.scss'
import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../common/utils/appUtils'
import { navigate } from '../../common/utils/redirectionUtils'
import {
  ACTIVE_STATUS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import PopupCard from '../Common/PopupCard/PopupCard'
import Alert from '../../components/Alert/Alert'
import {
  getPharmacyDataHelper,
  updatePharmacyDataHelper,
} from '../../helper/settings-helper'
import { downloadProductCatalogCSVAPI } from '../../adapter/adapter'

const PharmacyStore = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.PHARMACY_STORE,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [loginData, setLoginData] = useState({})
  const [manageStoreData, setManageStoreData] = useState([])
  const [filteredManageStoreData, setFilteredManageStoreData] =
    useState(manageStoreData)
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})
  const [showTemplatePopup, setShowTemplatePopup] = useState(false)
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState('')

  useEffect(() => {
    getPharmacyStoreData()
  }, [])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    let filteredStoreData = manageStoreData.filter(
      (store) =>
        store?.mobile_no?.toUpperCase()?.includes(searchTerm?.toUpperCase()) ||
        store?.name?.toUpperCase()?.includes(searchTerm?.toUpperCase())
    )

    setFilteredManageStoreData(filteredStoreData)
  }, [searchTerm])

  const getPharmacyStoreData = async () => {
    try {
      let data = await getPharmacyDataHelper()

      setManageStoreData(data)
      setFilteredManageStoreData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const hanleCardActtion = async (id, action) => {
    console.log('action clicked !!', action)

    try {
      let status = action === ACTIVE_STATUS.ACTIVE
      await updatePharmacyDataHelper(id, status)
      getPharmacyStoreData()
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const showAlert = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setTimeout(() => setAlertMessage(''), 3000)
  }

  const handleTemplateDownload = () => {
    setShowTemplatePopup(true)
  }

  const downloadTemplateFile = async (productType) => {
    try {
      setIsDownloadingTemplate(true)
      const response = await downloadProductCatalogCSVAPI(
        { product_type: productType },
        { responseType: 'blob' }
      )

      const blob = new Blob([response.data], {
        type: 'text/csv;charset=utf-8;',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `product_catalog_${productType}.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.log('Download template failed: ', err)
    } finally {
      setIsDownloadingTemplate(false)
      setShowTemplatePopup(false)
    }
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {alertMessage && (
        <Alert
          success={alertType === 'success'}
          alertType={alertType}
          alertMessage={alertMessage}
          onClose={() => setAlertMessage('')}
        />
      )}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Pharmacy Name/Number"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">
              Manage Pharmacy Store
            </div>
            <div className="addProductBtn dFlex aiCenter">

              <button
                className="btn btnPrimary"
                onClick={handleTemplateDownload}
              >
                template download
              </button>


            </div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search Pharmacy Name/Number"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="productLlistWrap dFlex">
          {filteredManageStoreData?.map((store) => {
            return (
              <div className="cardWrap">
                <Card
                  userInitials={convertToTitleCase((store?.pharmacy_name || store?.name)?.[0])}
                  headerSup={store.pharmacy_name ? `${store.pharmacy_name} (${store.name})` : store.name}
                  headerMain={`ID: ${store.id}`}
                  name={store.owner_name}
                  phone={store.mobile_no}
                  email={store.email}
                  rating={store.rating}
                  location={store.location}
                  isActive={store.is_active}
                  onboardAt={store.onboard_at}
                  cardAction={
                    permissions?.features?.[
                    PERMISSION_FEATURE.PHARMACY_STORE
                    ] === PERMISSION_TYPE.MANAGE &&
                    (store.is_active
                      ? [ACTIVE_STATUS.INACTIVE]
                      : [ACTIVE_STATUS.ACTIVE])
                  }
                  showBulkUpload={true}
                  branchId={store.id}
                  onBulkUploadComplete={getPharmacyStoreData}
                  onShowAlert={(type, message) => showAlert(message, type)}
                  onCardAction={(action) => hanleCardActtion(store.id, action)}
                />
              </div>
            )
          })}
        </div>
      </div>

      {showTemplatePopup && (
        <PopupCard
          header="Download Product Catalog Template"
          body="Select the product type to download the CSV template."
        >
          <div className="mb-10 dFlex flexColumn aiStart">
            <button
            >
            </button>

            <button
              className="btn btnPrimary "
              disabled={isDownloadingTemplate}
              onClick={() => downloadTemplateFile('PHARMACEUTICAL')}
            >
              PHARMACEUTICAL
            </button>
            <button
              className="btn btnPrimary mt-5 justifycent "
              disabled={isDownloadingTemplate}
              onClick={() => downloadTemplateFile('NON_PHARMACEUTICAL')}
            >
              NON PHARMACEUTICAL
            </button>
          </div>
          <button
            className="btn btnPrimaryOutlined mt-5"
            onClick={() => setShowTemplatePopup(false)}
          >
            Cancel
          </button>
        </PopupCard>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    // alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => { }

export default connect(mapStateToProps, undefined)(PharmacyStore)
